//@flow
import React from 'react';
import { Banner } from 'components/atoms/banner';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { useViewport } from 'components/templates/viewportProvider';
import { StringUtil } from 'utils/StringUtil';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
// eslint-disable-next-line
import "./styles.scss";

type Props = {
  theme: string,
  data: {
    banner: any,
  },
};

const PropertyBanner = (props: Props) => {
  const { height, isMobile } = useViewport();

  const {
    title,
    description,
    description_mobile,
    image,
    image_mobile,
    thumbnail,
    thumbnail_mobile,
    banner_video,
  } = props.data;
  let className = 'property-banner';
  let imageUrl = image;
  let thumbNail = thumbnail;
  const mobile_description = StringUtil.sliceHtml(description_mobile);

  const renderBannerTextMobile = () => {
    return (
      <div className={'banner-text'}>
        <h1>{title}</h1>
      </div>
    );
  };

  let bannerText = title;
  if (isMobile) {
    imageUrl = image_mobile;
    thumbNail = thumbnail_mobile;
    bannerText = renderBannerTextMobile();
  }

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        containerClassName={'property-banner-image'}
        imageUrl={imageUrl}
        thumbNailUrl={thumbNail}
        title={bannerText}
      />
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
      {/*<FooterExploreButton theme={theme} onClick={handleClick} />*/}
    </div>
  );
};

export default PropertyBanner;
